import React from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { bindActionCreators } from 'redux'
import StaticTextInput from '../../Components/StaticTextInput'
import helpers from '../../Utils/helpers'
import {useTranslation} from 'react-i18next';
import Spinner from "../../Components/Fundamentals/Spinner/Spinner";
import ToolTip, {TooltipContent, TooltipTrigger} from "../../Components/Overlays/Tooltip";
import {getEducationInfoMsg} from "../../Components/Customer/Educations/CourseList";
import DOMPurify from 'dompurify';
import customerActionsImp from "../../Actions/customerActions";
import {useStep} from "../../Hooks/useStep";
import {Button, ButtonDirection, ButtonOption} from "../../Components/Fundamentals/Button";


function EducationInfo({ eventId }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const selectedCourse = useSelector(state => state.CustomerReducer.selectedCourse)
    const customer = useSelector(state => state.CustomerReducer.customer);
    const userSalesNumber = useSelector(state => state.CommonReducer.user && state.CommonReducer.user.salesNumber);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const { onNext } = useStep();
    
    const onClickAction = (education) => {
        customerActions.startEducationBooking(createEducationFormData(education), education.id);
        onNext();
    }
    const createEducationFormData = (education) => {
        const vbCustomer = customer.vbCustomer;
        return {
            customerNumber: vbCustomer.customerNumber,
            invoiceCustomerNumber: vbCustomer.customerNumber,
            name: customer.name,
            contactFirstName: customer.contactPerson?.firstName ?? "",
            contactLastName: customer.contactPerson?.lastName ?? "",
            contactMobilenumber: customer.contactPerson?.phoneNumber,
            contactEmail: customer.contactPerson?.email ?? "",
            participantFirstName: "",
            participantLastName: "",
            participantMobilenumber: "",
            participantEmail: "",
            additionalInfo: "",
            bookTerms: false,
            salesNumber: userSalesNumber,
            leadId: "",
            reseller: "",
            couponCode: "",
            invoiceReference: "",
            courseId: education.id,
        }
    }
    const educationTable = (educations) => {
        const hasInfo = educations.some(e => e.bookingInfo > 0);

        return <table className={`table table-stripe table-hover${hasInfo ? " px-32" : ""}`}>
            <thead>
            <tr>
                <th className="text-left">{t('common.startdate')}</th>
                <th className="text-left">{t('common.enddate')}</th>
                <th className="text-left">{t('common.address')}</th>
                <th className="text-left">{t('educations.location')}</th>
                <th className="text-left">{t('educations.participantsbooked')}</th>
                <th className="text-left">{t('educations.minimumparticipants')}</th>
                <th className="text-left">{t('educations.maximumparticipants')}</th>
                <th className="text-left">{t('common.price')}</th>
                <th className="text-left"></th>
            </tr>
            </thead>
            <tbody>
            {educations.map((education, index) => {
                let hasInfo = education.bookingInfo > 0
                let hasError = education.bookingInfo > 20;
                return <tr className={`${hasInfo ? "hasError" : "cursorpointer"}`}
                           onClick={hasError ? undefined : () => onClickAction(education)} key={index}>
                    <td style={{whiteSpace: "nowrap"}}>{hasInfo && <span className="indent-error">
                        <ToolTip placement={'left'} arrowPlacement={'right in'}>
                                <TooltipTrigger>
                                    <span
                                        className={`vismaicon vismaicon-sm vismaicon-filled vismaicon-${hasError ? 'error' : 'warning'}`}></span>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <div>{getEducationInfoMsg(education, t)}</div>
                                </TooltipContent>
                            </ToolTip>
                    </span>}{education.onDemand ? t('educations.frombooking') : education.date}</td>
                    <td style={{whiteSpace: "nowrap"}}>{education.onDemand ?+ education.onDemandAccessDays + t('educations.daysafterbooking') : education.endDate}</td>
                    <td>{education.addressName}</td>
                    <td>{education.location}</td>
                    <td>{education.participantsBooked}</td>
                    <td>{education.onDemand ? '-' : education.minimumParticipants}</td>
                    <td>{education.onDemand ? '-' : education.maximumParticipants}</td>
                    <td>{helpers.currencyFormatter(education.price)}</td>
                    <td>
                        <Button disabled={hasError} direction={ButtonDirection.RIGHT} option={!hasError && education.id === eventId ? ButtonOption.PRIMARY : ButtonOption.DEFAULT}>{t('common.book')}</Button>
                    </td>
                </tr>
            })}
            </tbody>
        </table>
    }

    if (!selectedCourse)
        return <Spinner />;
    
    return (
        <div>
            <div className="form-horizontal">
                <fieldset className="col-xs-6">
                    <div className="panel panel-default">
                        <div className="panel-heading">{t('educations.courseinfo')}</div>
                        <div className="panel-body">
                            <StaticTextInput label={t('common.name')} value={selectedCourse.courseName} />
                            {selectedCourse.days != null && <StaticTextInput label={t('educations.days')} value={selectedCourse.days} />}
                            <StaticTextInput label={t('educations.level')} value={selectedCourse.courseLevel} />
                            <StaticTextInput label={t('educations.category')} value={selectedCourse.subjects && selectedCourse.subjects.join(', ')} />
                        </div>
                    </div>
                </fieldset>
                <fieldset className="col-xs-6">
                    <div><p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedCourse.targetGroup) }} /></div>
                    <div><p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedCourse.prerequisites) }} /></div>
                </fieldset>
                <fieldset className="col-xs-12">
                    <div><p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedCourse.courseDescriptionShort) }} /></div>
                    <div><p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedCourse.courseDescription) }} /></div>
                    <div><p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedCourse.notes) }} /></div>
                    <div><p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedCourse.courseGoal) }} /></div>
                </fieldset>
                <fieldset className="col-xs-12">
                    {educationTable(selectedCourse.educations)}
                </fieldset>
            </div>

        </div>
    )

}

export default EducationInfo;